import React, { useEffect, useState, useContext, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  Box,
  Typography,
  Button,
  CircularProgress,
  Alert
} from "@mui/material";
import { AuthContext } from "../../contexts/AuthContext";
import ComponentLoading from "../../components/App/ComponentLoading";

const MicrosoftSsoCallbackPage = () => {
  const [searchParams] = useSearchParams();
  const { completeMicrosoftSSOCallback } = useContext(AuthContext);
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(true);
  const handledRef = useRef(false);
  const navigate = useNavigate();

  useEffect(() => {
    const code = searchParams.get("code");
    const state = searchParams.get("state");
    const err = searchParams.get("error");

    if (!code && !state && !err) {
      return;
    }

    if (handledRef.current) return;
    handledRef.current = true;

    (async () => {
      try {
        await completeMicrosoftSSOCallback({ code, state, error: err });
      } catch (e) {
        const msg =
          typeof e?.message === "string"
            ? e.message
            : "Sign-in could not be completed. Please try again.";
        setError(msg);
        setBusy(false);
      }
    })();
  }, [searchParams, completeMicrosoftSSOCallback]);

  if (busy && !error) {
    return (
      <ComponentLoading
        size='large'
        message='Completing Microsoft sign-in…'
        fullHeight
      />
    );
  }

  if (error) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "60vh",
          px: 2,
          maxWidth: 480,
          mx: "auto"
        }}
      >
        <Alert severity='error' sx={{ width: "100%", mb: 2 }}>
          {error}
        </Alert>
        <Button
          variant='contained'
          onClick={() => navigate("/auth?request_type=login")}
        >
          Back to sign in
        </Button>
      </Box>
    );
  }

  return null;
};

export default MicrosoftSsoCallbackPage;
